import { render } from "./sourcing-events.vue?vue&type=template&id=b9fbe1c0&scoped=true"
import script from "./sourcing-events.vue?vue&type=script&lang=js"
export * from "./sourcing-events.vue?vue&type=script&lang=js"

import "./sourcing-events.vue?vue&type=style&index=0&id=b9fbe1c0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9fbe1c0"]])

export default __exports__